import { translation } from 'I18n/i18n'
import ScrollContainer from 'components/scrollContainer/scrollContainer'
import ScrollSection from 'components/scrollSection/scrollSection'
import AnchorButtonContext from 'contexts/anchorButton'
import CounterContext from 'contexts/counter'
import HeadbandContext from 'contexts/headband'
import { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import englishCondition from '../englishAssert'

interface IProps {
   visiteur?:boolean
}

export default function Urgences(props: IProps) {
   const lang = useSelector((state: any) => state.languageReducer.language)
   const [altLanguage] = useState(englishCondition(lang, props.visiteur))
   const { setCounter, counterDefault } = useContext(CounterContext)
   const { setHeadband } = useContext(HeadbandContext)
   const { setAnchorButton } = useContext(AnchorButtonContext)

   useEffect(() => {
      setCounter(counterDefault)
      setHeadband(translation(lang, 'urgences', 'title'))
      setAnchorButton([])
   }, [])

   return (
      <ScrollContainer>
         <ScrollSection zoneName={altLanguage ? "Emergency and safety" : `Urgence et règles de sécurité`} />
      </ScrollContainer>
   )
}
